/* tslint:disable */
/* eslint-disable */
/**
 * Apperta Physical Health REST API
 * Apperta Physical Health REST API
 *
 * The version of the OpenAPI document: 0.2.0-SNAPSHOT2
 * Contact: info@staircase13.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Clinician
 */
export interface Clinician {
    /**
     * 
     * @type {string}
     * @memberof Clinician
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Clinician
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Clinician
     */
    namespace?: string;
}

/**
 * Check if a given object implements the Clinician interface.
 */
export function instanceOfClinician(value: object): value is Clinician {
    return true;
}

export function ClinicianFromJSON(json: any): Clinician {
    return ClinicianFromJSONTyped(json, false);
}

export function ClinicianFromJSONTyped(json: any, ignoreDiscriminator: boolean): Clinician {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'namespace': json['namespace'] == null ? undefined : json['namespace'],
    };
}

export function ClinicianToJSON(value?: Clinician | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'namespace': value['namespace'],
    };
}

